import { STATUS_PENDING } from 'containers/LawyerFeeNote/constants';
import { isEmpty, get } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { OPENING_STATE } from 'services/constants';
import { BeneficiaryType, VictimType } from 'typings/globalTypes';
const emptyToNull = <T>(value: T): T | null => {
  if (value === '') return null;
  if (Array.isArray(value)) return (value.map(emptyToNull) as unknown) as T;
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, emptyToNull(v)]),
    ) as T;
  }
  return value;
};

export const formatVictimsToAdd = (
  victimValues: VictimType[],
  claimId: number,
  openingState: string,
) => {
  const formatedBeneficiaries = !isEmpty(get(victimValues, '[0].beneficiaries'))
    ? get(victimValues, '[0].beneficiaries').map((element: BeneficiaryType) => {
        return {
          ...element,
          funeralFees:
            ((element.funeralFees as unknown) as string) === ''
              ? undefined
              : Number(element.funeralFees),
        };
      })
    : get(victimValues, '[0].beneficiaries');
  return [...victimValues].map((el: VictimType) => {
    delete ((el as unknown) as any).id;
    return {
      ...emptyToNull(el),
      dateOfBirth: el.dateOfBirth,
      claimId: claimId,
      isExcluded: !!el.isExcluded,
      beneficiaries: formatedBeneficiaries,
      decision:
        openingState === OPENING_STATE.NOT_COMPLETED &&
        featureService.hasFeature(FEATURES.OPENING_BY_USAGE)
          ? undefined
          : {
              status: STATUS_PENDING,
            },
    };
  });
};
